import React, { useContext, useState } from 'react';
import './Teaching.module.scss';
import Button from 'components/UI/Button';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { Tooltip } from 'react-tippy';
import { QuizContext } from 'screens/Quiz/Quiz';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProgressBar from '../../ProgressBar/ProgressBar';
import TeachingCard from './components/TeachingCard/TeachingCard';

const buttons = [
    {
        image: '/images/test/teaching/docent.jpg',
        title: 'Leerkracht/docent',
        description:
            'Voor onderwijsprofessionals die wat anders willen zijn er legio mogelijkheden binnen de sector. Bijvoorbeeld je eerstegraads bevoegdheid halen, verdiepende masters of post-hbo opleiding, een tweede bevoegdheid. Vaak zijn daar ook subsidies voor.',
        answerLabel: 'teacher',
    },
    {
        image: '/images/test/teaching/onderwijs-assistent.jpg',
        title: 'Onderwijsassistent (met relevante werkervaring)',
        description:
            'Er zijn geen wettelijke bevoegdheidseisen om als klassenassistent, onderwijsassistent of leraarondersteuner te kunnen werken. Wel zijn er verschillende opleidingsmogelijkheden.',
        answerLabel: 'assistant',
    },
    {
        image: '/images/test/teaching/instructeur.jpg',
        title: 'Instructeur/technisch onderwijsassistent (TOA)',
        description:
            'Docenten en instructeurs maken allebei deel uit van het onderwijsteam binnen een mbo-school. Instructeurs houden zich vooral bezig met de praktijkonderdelen binnen een opleiding en dragen geen eindverantwoordelijkheid.  ',
        answerLabel: 'instructor',
    },
];

export default function Teaching() {
    const [activeButton, setActiveButton] = useState(null);
    const { setQuestionIndex, setAnswers, answers } = useContext(QuizContext);

    function toNextScreen() {
        setQuestionIndex((prev) => prev + 1);
        setAnswers({
            ...answers,
            question3: buttons[activeButton].answerLabel,
        });
    }

    return (
        <div styleName="teaching">
            <div styleName="title">
                <h2>Welke soort functie heeft jouw voorkeur?</h2>
                <ProgressBar />
            </div>
            <div styleName="question">
                <div styleName="buttons">
                    {buttons.map((button, index) => (
                        <TeachingCard
                            onClick={() => {
                                setActiveButton(index);
                            }}
                            content={button}
                            active={activeButton === index}
                            key={index}
                        />
                    ))}
                </div>
                <div styleName="bottom-button-wrapper">
                    <Button
                        color="blue-gray"
                        onClick={() => setQuestionIndex((prev) => prev - 1)}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                        Vorige
                    </Button>
                    <Tooltip
                        // theme="light"
                        disabled={activeButton !== null}
                        style={{ width: 'fit-content' }}
                        title="Je hebt nog geen antwoord ingevuld"
                    >
                        <Button
                            color="blue"
                            disabled={activeButton === null}
                            icon={faArrowRight}
                            onClick={toNextScreen}
                        >
                            Volgende
                        </Button>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
}
